import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import classnames from 'classnames';

import { i18n } from 'config/locales';
import { ErrorList } from 'components/ErrorList';
import { formTypes } from 'config/formTypes';
import { LEGAL } from 'constants/sections';
import SectionNavigation from 'components/Section/shared/SectionNavigation';
import { rootSelectors } from '@redux/modules/selectors';
import Offenses from './Police/Offenses';
import OtherOffenses from './Police/OtherOffenses';
import DomesticViolenceList from './Police/DomesticViolenceList';
import {
  History, Revoked, Debarred, ClearanceIssues, PivIssues, ForeignInvestigations, InvestigationsIntro
} from './Investigations';
import {
  NonCompliance, Unauthorized, Manipulating, Unlawful, HandlingProtectedInformationIntro, ProtectedUnauthorized, Denied, TechnologyIntro
} from './Technology';
import NonCriminalCourtActions from './NonCriminalCourtActions';
import {
  TerroristOrganization,
  TerroristOrganizationMembership, // PVQ
  TerrorismEngagement, // PVQ
  TerrorismAdvocacy, // PVQ
  RightsSuppressionGroup, // PVQ
  ViolentRightsSuppressionGroup, // PVQ
  ViolentOrganization, // PVQ
  ViolentActs, // PVQ
  HateCrimeAdvocacy, // PVQ
  InternationalAndDomesticTerrorism, // PVQ
  InternationalAndDomesticTerrorismEngagement, // PVQ
  InternationalAndDomesticTerrorismAssociation, // PVQ
  InternationalAndDomesticTerrorismAdvocacy, // PVQ
  MembershipOverthrow,
  MembershipViolence,
  EngagedInTerrorism,
  Advocating,
  ActivitiesToOverthrow,
  TerrorismAssociation,

} from './Associations';
import Intro from './Intro';
import PoliceIntro from './Police/Intro';
import Review from './Review';
import SectionNotFound from '../shared/SectionNotFound';
import CriminalConvictions from './CriminalConvictions';

const Legal = function ({
  subsection, location, formType, isReview
}) {
  const subsectionLibrary = {
    intro: Intro,
    'police/intro': PoliceIntro,
    'police/offenses': Offenses,
    'police/additionaloffenses': OtherOffenses,
    'police/domesticviolence': DomesticViolenceList,
    'investigations/intro': InvestigationsIntro,
    'investigations/history': History,
    'investigations/revoked': Revoked,
    'investigations/clearanceissues': ClearanceIssues,
    'investigations/pivissues': PivIssues,
    'investigations/debarred': Debarred,
    'investigations/foreign': ForeignInvestigations,
    court: NonCriminalCourtActions,
    'technologyprotected/intro': HandlingProtectedInformationIntro,
    'technologyprotected/protectedunauthorized': ProtectedUnauthorized,
    criminalConvictions: CriminalConvictions,
    'technology/intro': TechnologyIntro,
    'technology/unauthorized': Unauthorized,
    'technologyprotected/noncompliance': NonCompliance,
    'technology/manipulating': Manipulating,
    'technology/denied': Denied,
    'technology/unlawful': Unlawful,
    'associations/terrorist-organization': TerroristOrganization,
    'associations/terrorist-organization-membership': TerroristOrganizationMembership, // PVQ
    'associations/terrorism-engagement': TerrorismEngagement, // PVQ
    'associations/terrorism-advocacy': TerrorismAdvocacy, // PVQ
    'associations/rights-suppression-group': RightsSuppressionGroup, // PVQ
    'associations/violent-rights-suppression-group': ViolentRightsSuppressionGroup, // PVQ
    'associations/violent-organization': ViolentOrganization, // PVQ
    'associations/violent-acts': ViolentActs, // PVQ
    'associations/hate-crime-advocacy': HateCrimeAdvocacy, // PVQ
    'associations/international-and-domestic-terrorism': InternationalAndDomesticTerrorism, // PVQ
    'associations/international-and-domestic-terrorism-engagement': InternationalAndDomesticTerrorismEngagement, // PVQ
    'associations/international-and-domestic-terrorism-association': InternationalAndDomesticTerrorismAssociation, // PVQ
    'associations/international-and-domestic-terrorism-advocacy': InternationalAndDomesticTerrorismAdvocacy, // PVQ
    'associations/engaged-in-terrorism': EngagedInTerrorism,
    'associations/advocating': Advocating,
    'associations/membership-overthrow': MembershipOverthrow,
    'associations/membership-violence-or-force': MembershipViolence,
    'associations/activities-to-overthrow': ActivitiesToOverthrow,
    'associations/terrorism-association': TerrorismAssociation,
    review: Review,
  };

  const form = formTypes[formType];
  const section = form.find((s) => s.key === LEGAL);
  const flattenedSections = formTypes.reduceSubsections([section]);
  const subsectionClasses = classnames('view', `view-${subsection.name}`);

  const title = isReview && i18n.t('review.title');
  const para = isReview && i18n.m('review.para');

  return (
    <div className="legal">
      <div className="section-view">
        {title && <h1 className="title">{title}</h1>}
        {para}

        <div className={subsectionClasses}>
          {isReview && (
            <div className="top-btns">
              <ErrorList />
            </div>
          )}

          <Switch>
            {flattenedSections.map((sub) => (
              <Route key={sub.key} path={sub.fullPath} component={subsectionLibrary[sub.name]} />
            ))}
            <Route component={SectionNotFound} />
          </Switch>

          <SectionNavigation currentPath={location.pathname} />
        </div>
      </div>
    </div>
  );
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  subsection: state.section.subsection,
  isReview: rootSelectors.section.getIsSectionInReview(state),
  formType: rootSelectors.application.getFormType(state),
});

Legal.propTypes = {
  subsection: PropTypes.object,
  location: PropTypes.object,
  formType: PropTypes.string,
  isReview: PropTypes.bool,
};

Legal.defaultProps = {
  subsection: {},
  location: {},
};

export var LegalSections = function () {
  return <Review />;
};

export default connect(mapStateToProps)(Legal);
